import styled from 'styled-components';
import { Colors, Spacing, StackChildren } from '@doordash/design-language';
import { Heading } from './ModifierGroupView/styles';

export const RecommendationCard = styled(StackChildren)`
  border-radius: ${Spacing.XxxSmall}px;
  min-height: 180px;
  transition: opacity 0.5s ease-out, transform 0.7s ease-out;
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  ${({ visible }) => (visible ? '' : 'transform: translateX(-100%)')};
`;

export const CarouselIcon = styled.img<{ fromCart?: boolean }>`
  height: ${({ fromCart }) => (fromCart ? `68px` : `118px`)};
  width: ${({ fromCart }) => (fromCart ? `68px` : `118px`)};
  min-height: ${({ fromCart }) => (fromCart ? `68px` : `118px`)};
  min-width: ${({ fromCart }) => (fromCart ? `68px` : `118px`)};
  border-radius: ${Spacing.XxSmall}px;
  border: 1px solid ${Colors.BorderPrimary};
  object-fit: cover;
`;

export const MissingImageIcon = styled.div<{ fromCart?: boolean }>`
  height: ${({ fromCart }) => (fromCart ? `68px` : `118px`)};
  width: ${({ fromCart }) => (fromCart ? `68px` : `118px`)};
  min-height: ${({ fromCart }) => (fromCart ? `68px` : `118px`)};
  min-width: ${({ fromCart }) => (fromCart ? `68px` : `118px`)};
  border-radius: ${Spacing.XxxSmall}px;
  background-color: #f8fafc;
  border: ${({ fromCart }) => (fromCart ? '' : `1px solid ${Colors.BorderPrimary}`)};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CarouselItem = styled.span`
  margin-top: ${Spacing.XxxSmall + Spacing.XxxxSmall}px !important;
  font-family: 'Roboto';
  font-style: normal;
  line-height: ${Spacing.Medium}px;
  letter-spacing: 0.75px;
`;

export const CarouselItemNameWrapper = styled.div`
  display: flex;
  align-items: top;
  justify-content: flex-start;
  height: auto;
  margin-top: 6px;
`;
export const CarouselItemName = styled.div`
  font-weight: 700;
  font-size: ${Spacing.XSmall + Spacing.XxxxSmall}px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  max-height: 2 lines;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${Colors.ButtonLinkForeground};
  width: 118px;
`;

export const CarouselItemPrice = styled(CarouselItem)`
  font-weight: 400;
  font-size: ${Spacing.XSmall}px;
  color: ${Colors.TextTertiary};
`;

export const MobileSpacing = styled.span`
  border-top: ${Spacing.XxxSmall + Spacing.XxxxSmall}px solid var(--color-neutral__line);
  padding: 1.25rem 1.25rem ${Spacing.None};
`;

export const ItemModalHeading = styled(Heading)`
  padding-bottom: 0.5rem;
  font-weight: 700;
  font-size: ${Spacing.Small}px;
  margin-bottom: ${Spacing.Small}px;
`;

export const DesktopCartHeading = styled.h3`
  color: var(--color-neutral__title-active);
  font-weight: bold;
  letter-spacing: 1px;
  margin-bottom: ${Spacing.XxSmall}px;
`;

export const MobileCartHeading = styled(DesktopCartHeading)`
  margin-bottom: ${Spacing.XxSmall}px;
  font-size: 20px;
`;

export const IconButton = styled.div`
  box-shadow: ${Spacing.None}px ${Spacing.XxxxSmall}px ${Spacing.XxSmall}px ${Spacing.None}px #00000033;
  width: ${Spacing.Large}px;
  height: ${Spacing.Large}px;
  border-radius: ${Spacing.Medium}px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: white;
`;

export const IconWrapper = styled.div`
  margin-top: -32px !important;
  margin-right: ${Spacing.XxSmall}px;
  margin-bottom: ${Spacing.XSmall}px;
  display: flex;
  justify-content: end;
  align-items: right;
`;

export const CartIconWrapper = styled(IconWrapper)`
  margin-top: 0px !important;
`;

export const StepperWrapper = styled.div`
  align-items: center;
  box-shadow: ${Spacing.None}px ${Spacing.XxxxSmall}px ${Spacing.XxSmall}px ${Spacing.None}px #00000033;
  width: ${Spacing.XxxxLarge}px;
  height: ${Spacing.XLarge}px;
  border-radius: ${Spacing.Medium}px;
  display: flex;
  justify-content: space-around;
  background-color: white;
`;

export const StepperIconWrapper = styled.span`
  padding-top: ${Spacing.XxxSmall}px;
  svg {
    transform: scale(0.8);
  }
`;

export const RecommendationContainer = styled.div`
  overflow: hidden;

  display: flex;
  flex-direction: column;
  width: 100%;
  heigh: 100%;
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const Carousel = styled.div`
  overflow: hidden;
  display: flex;
  gap: 0.5rem;
  width: 100%;
  height: 100%;
  scroll-snap-type: x;
  overflow: auto hidden;
  padding: 0;

  scroll-behavior: smooth;

  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;
